import * as React from 'react';
export const jcbSvg = React.forwardRef(function jcbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E6EBF1',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Zm-1 0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#047AB1',
        d: 'M2.5 11h1.759c.628 0 1.241-.893 1.241-1.5V5H3.88c-.63 0-1.38.703-1.38 2v4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#D42D06',
        d: 'M6.5 11h1.759c.628 0 1.241-.893 1.241-1.5V5H7.88c-.63 0-1.38.703-1.38 2v4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#67B637',
        d: 'M10.5 11h1.759c.628 0 1.241-.893 1.241-1.5V5h-1.62c-.629 0-1.38.703-1.38 2v4Z',
      }),
    ),
  );
});
jcbSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var jcb = {
  category: 'card',
  colorable: false,
  name: 'jcb',
  svg: jcbSvg,
};
